import React from 'react';
import './BackgroundWrapper.css';
import bg1 from '../features/attackSurface/assets/background-1.png';
import bg2 from '../features/attackSurface/assets/background-2.png';
import union from '../features/attackSurface/assets/union.png';

interface BackgroundWrapperProps {
  children: React.ReactNode;
}

const BackgroundWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="background-wrapper">
    <img src={bg1} alt="" className="bg-img bg-img-1" />
    <img src={bg2} alt="" className="bg-img bg-img-2" />
    <img src={union} alt="" className="bg-img bg-img-union" />
    <div className="background-content">{children}</div>
  </div>
);

export default BackgroundWrapper;